import {from} from "rxjs";
import {filter, tap} from "rxjs/operators";
import {StopScrollEvent} from "../concat-scroll";

export const bidirectionalPageRange = (fromNumber, toNumber ) => {
    const arr =[];
    let val = fromNumber;
    console.log('sadsadasd',arr)
    if( fromNumber < toNumber) {
        val++;
        while (val <= toNumber){
            arr.push(val);
            val++;
            console.log('sadsadasd',val)
        }
    }else{
        while (val > toNumber){
            arr.push(val);
            val--;
            console.log('sadsadasd',val)
        }
    }
    console.log(arr);
    return from(arr).pipe(
        // concatMap( i => i === arr[0] ? of(i) : of(i).pipe(delay(200)))
    );
};

export const log = (tag )=>{
    return tap( e => console.log(tag, e));
};

export const onlyMovedUp = () => {
    return filter( (e: StopScrollEvent) => !e.movedDown)
};
export const onlyMovedDown = () => {
    return filter( (e:StopScrollEvent) => e.movedDown)
};
